import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import NumberInput from "@/components/inputs/number.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {onBeforeMount, PropType, ref} from "vue"
  import {Customer} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import {Customer as CustomerClient} from "@/endpoints/rutsolve/gql/resolvers/customer"
  import ErrorModal from "@/components/modals/error.vue"
  import Enumeration from "@/components/selectors/enumeration.vue"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'customer',
  props: /*@__PURE__*/_mergeModels({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<Customer>
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  

  onBeforeMount(() => {
    read()
  })

  const value = _useModel(__props, "value")

  const error = ref<Error>(null)
  const enumerationClient = new EnumerationClient()
  const customerClient = new CustomerClient()
  const customerTypes = ref<string[]>(null)

  async function read() {
    try {
      const response = await enumerationClient.readCustomerEnumerations()
      customerTypes.value = response.types
    } catch(e) {
      error.value = e
    }
  }

  async function updateNumber() {
    try {
      value.value.number = await customerClient.newNumber()
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (value.value)
    ? (_openBlock(), _createBlock(_component_scoped, { key: 0 }, {
        default: _withCtx(() => [
          (customerTypes.value)
            ? (_openBlock(), _createBlock(Enumeration, {
                key: 0,
                selection: value.value.type,
                "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((value.value.type) = $event)),
                title: "Type",
                options: customerTypes.value,
                readOnly: __props.readOnly,
                onUpdate: _cache[1] || (_cache[1] = ($event: any) => (updateNumber()))
              }, null, 8, ["selection", "options", "readOnly"]))
            : _createCommentVNode("", true),
          _createVNode(TextInput, {
            value: value.value.name,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((value.value.name) = $event)),
            title: "Name",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(NumberInput, {
            value: value.value.number,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((value.value.number) = $event)),
            title: "Number",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          _createVNode(TextInput, {
            value: value.value.memorandum,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((value.value.memorandum) = $event)),
            title: "Memorandum",
            multiline: "",
            readOnly: __props.readOnly
          }, null, 8, ["value", "readOnly"]),
          (error.value)
            ? (_openBlock(), _createBlock(ErrorModal, {
                key: 1,
                error: error.value,
                "onUpdate:error": _cache[5] || (_cache[5] = ($event: any) => ((error).value = $event))
              }, null, 8, ["error"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})